import React from "react";
import ServicesHero from "./ServicesHero";
import Footer from "../Footer";
import ServicesCta from "./ServicesCta";
import ServicesGrid from "./ServicesGrid";
import OurServices_2 from '../main_page/OurServices_2'
import Reveal from "../../components/Reveal";
import ContactCta from "../main_page/ContactCta";

export default function ServicesPage() {
  return (
    <div className="services-page">
      <Reveal as="section" variant="fade" duration={0.8} threshold={0.15}>
        <ServicesHero />
      </Reveal>

      <Reveal as="section" variant="fade" duration={0.8} threshold={0.15}>
        <OurServices_2 />
      </Reveal>

      {/* Грід послуг — плавно виїжджає вгору
      <Reveal as="section" variant="up">
        <ServicesGrid />
      </Reveal> */}

      {/* Call-to-action з fade/zoom
      <Reveal as="section" variant="zoom" delay={0.08}>
        <ServicesCta />
      </Reveal> */}

      <Reveal as="section" variant="zoom" delay={0.08}>
        <ContactCta />
      </Reveal>

      {/* Footer — fade */}
      <Reveal as="footer" variant="fade" delay={0.12}>
        <Footer />
      </Reveal>
    </div>
  );
}
